import { render, staticRenderFns } from "./RegisterPageDesktopEllipse.vue?vue&type=template&id=17cbcfd4&scoped=true&"
import script from "./RegisterPageDesktopEllipse.vue?vue&type=script&lang=js&"
export * from "./RegisterPageDesktopEllipse.vue?vue&type=script&lang=js&"
import style0 from "./RegisterPageDesktopEllipse.vue?vue&type=style&index=0&id=17cbcfd4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17cbcfd4",
  null
  
)

export default component.exports